import { render, staticRenderFns } from "./Soporte.vue?vue&type=template&id=672b982e&scoped=true"
import script from "./Soporte.vue?vue&type=script&lang=js"
export * from "./Soporte.vue?vue&type=script&lang=js"
import style0 from "./Soporte.vue?vue&type=style&index=0&id=672b982e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b982e",
  null
  
)

export default component.exports